import { useState } from 'react';
import ReactLoading from 'react-loading';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
export const EmailValidation = () => {
  const [inputs, setInputs] = useState({ email: '' });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleChange = (e) => {
    const target = e.target;
    const { value, name } = target;
    setInputs((input) => ({
      ...input,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/recover-password/one`,
        inputs
      );
      toast.success(response.data.message);
      sessionStorage.setItem('resetUserEmail', JSON.stringify(inputs.email));
      navigate('/changepassword');
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='h-screen relative max-w-lg mx-auto'>
      <div className='w-full  pb-16 bg-p-wh flex items-center flex-col gap-8 rounded-lg absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pt-16 px-6'>
        <div className='font-pin  text-center'>
          <h1 className='text-2xl font-semibold text-p-pin pb-2'>
            Email Verification
          </h1>
          <p>
            Enter your registered email address to receive a verification code
          </p>
        </div>
        <form
          className='flex items-center flex-col gap-4 w-full box-border'
          onSubmit={handleSubmit}
        >
          <div className='flex flex-col gap-2 w-full'>
            <label className='text-p-bk text-base font-pin'>
              Email address<sup className='text-red-500'>*</sup>
            </label>
            <input
              type='email'
              className='focus:outline-none focus:ring focus:b-mc border-2 w-full h-11 rounded-lg border-t-bk px-4'
              name='email'
              value={inputs.email}
              onChange={handleChange}
            />
          </div>

          <button
            className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-4 py-2.5 w-full my-4 font-semibold disabled:bg-b-mct bg-b-mc rounded-lg relative'
            disabled={isLoading}
          >
            Login
            {isLoading ? (
              <ReactLoading
                type='cylon'
                color='#5AC8FA'
                height={44}
                width={44}
                className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
              />
            ) : null}
          </button>
        </form>
      </div>
    </div>
  );
};
